import {
  ClientAccountStatusType,
  OnboardingStatusType,
} from 'api/types/entity';

export const shouldShowResultCheckInput = (
  currentStatus: OnboardingStatusType | ClientAccountStatusType | null
) => {
  switch (currentStatus) {
    case OnboardingStatusType.ValidationCheck:
    case OnboardingStatusType.ComplianceCheck:
    case OnboardingStatusType.AmlCftCheck:
    case OnboardingStatusType.AwaitingPaymentConfirmation:
    case OnboardingStatusType.BoardReview:
      return true;

    default: {
      return false;
    }
  }
};
